import Cookies from 'js-cookie'
import { isLocalDev } from '@/utils'

export default {
  namespaced: true,
  state: {
    lang: 'en'
  },
  mutations: {
    recoverLanguage (state) {
      const language = Cookies.get('yz_language')
      if (language) {
        state.lang = language
      } else {
        let domain = `.${process.env.VUE_APP_BASE_DOMAIN}`
        let secure = true
        if (isLocalDev()) {
          domain = window.location.hostname
          secure = false
        }
        Cookies.set('yz_language', state.lang, { secure, domain, expires: 90 })
      }
    },
    setLanguage (state, language) {
      state.lang = language
      let domain = `.${process.env.VUE_APP_BASE_DOMAIN}`
      let secure = true
      if (isLocalDev()) {
        domain = window.location.hostname
        secure = false
      }
      Cookies.set('yz_language', language, { secure, domain, expires: 90 })
    }
  },
  getters: {
    getLanguage (state) {
      return state.lang
    }
  }
}